import { forwardRef, useEffect, useRef, useState } from "react";
import { useLazyGetAllDropDownsForMemberDirectoryQuery } from "../../../../../app/services/common/commonApi";
import { useLazyGetManualAccountByMemberIdQuery } from "../../../../../app/services/GMAP/gmapApplicationTaskListApi";
import FormCreator from "../../../../../components/Forms/FormCreator";
import MolGrid from "../../../../../components/Grid/MolGrid";
import { dateviewManualAccountData, ViewManualAccountconfig, viewManualAccountData } from "./GmpmanualData";
import { decryptAESID } from "../../../../../utils/Encryption";
import { useParams } from "react-router-dom";
import { setFieldParameters } from "./utils/setFieldParameter";
import { APIUrl } from "../../../../../utils/API/fetchBaseQuery";

const GmpManualForm = forwardRef(() => {
    const viewManualAccountRef = useRef();
    const dateviewManualAccountRef = useRef();
    const molGrifRef = useRef();
    const [dataSource, setDataSource] = useState();
    const { id } = useParams();
    const editID = id ? decryptAESID(id, false) : 0
    const [formData, setFromData] = useState(viewManualAccountData);
    const [dateFormData, setDateFormData] = useState(dateviewManualAccountData)
    const [getManualAccountByMemberId, { isSuccess: isSuccess, isFetching: isFetching, data: manualAccountByMemberIdResponse },] = useLazyGetManualAccountByMemberIdQuery();
    useEffect(() => {
        if (editID) {
            getManualAccountByMemberId(editID);
        }
    }, [editID])

    useEffect(() => {
        if (isSuccess && !isFetching && manualAccountByMemberIdResponse) {
            setFieldParameters(manualAccountByMemberIdResponse);
            // setDataSource(manualAccountByMemberIdResponse?.getDocumentList)
            const updatedDocumentList = manualAccountByMemberIdResponse?.getDocumentList?.map(documant => ({
                ...documant,
                certificateLink: `${APIUrl}/Common/getPDF?type=AttendanceCert&fileName=${documant?.documentProof}`
            }));
            setDataSource(updatedDocumentList)
        }
    }, [isSuccess, isFetching, manualAccountByMemberIdResponse]);

    return (
        <>
            <div className="row">
                {!isFetching &&
                    <FormCreator
                        ref={viewManualAccountRef}
                        {...formData}
                    />
                }
            </div>
            <MolGrid
                ref={molGrifRef}
                configuration={ViewManualAccountconfig}
                dataSource={dataSource}
                allowPagination={false}
            />
            <FormCreator
                ref={dateviewManualAccountRef}
                {...dateFormData}
            />
        </>
    );
});

export default GmpManualForm;
